import { Button, Card, CardContent, CardHeader, FormLabel, Grid2, MenuItem, Select, TextField } from "@mui/material";
import { API_HOST, JENIS_BERKAS } from "../../helper/Constant";
import LoadingButton from '@mui/lab/LoadingButton';
import { CloudUpload } from "@mui/icons-material";
import { useState } from "react";
import { Commons } from "../../helper/CommonService";
import ShowNotif from "../general/ShowNotif";

function DetailUpload({ idSantri, forceRefresh }) {
    const [selectedFile, setSelectedFile] = useState(null);
    const [typeFile, setTypeFile] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isShowNotif, setIsShowNotif] = useState(false);
    const [notifData, setNotifData] = useState({});

    const handleChange = (event) => {
        const file = event.target.files[0];
        
        // Validate file
        if (file) {
            // Check file size (5MB = 5 * 1024 * 1024 bytes)
            if (file.size > 5 * 1024 * 1024) {
                setNotifData({
                    message: "Ukuran file terlalu besar. Maksimal 5MB",
                    status: "error"
                });
                setIsShowNotif(true);
                event.target.value = null; // Reset input
                return;
            }

            // Check file type
            const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
            if (!allowedTypes.includes(file.type)) {
                setNotifData({
                    message: "Format file tidak didukung. Gunakan JPG atau PNG",
                    status: "error"
                });
                setIsShowNotif(true);
                event.target.value = null; // Reset input
                return;
            }

            setSelectedFile(file);
        }
    };

    const UploadFile = async () => {
        if (!selectedFile || !typeFile) {
            setNotifData({
                message: "Pilih file dan jenis berkas terlebih dahulu",
                status: "error"
            });
            setIsShowNotif(true);
            return;
        }

        setIsLoading(true);

        try {
            // ✅ Step 1: Upload file to /files with required 'type' field
            const formData = new FormData();
            formData.append('type', selectedFile.type); // ✅ REQUIRED: MIME type
            formData.append('storage', 'local'); // Required!
            formData.append('title', JENIS_BERKAS[typeFile]+'_'+idSantri); // Optional: human-readable title
            formData.append('filename_download', typeFile+'_'+idSantri); // Optional: download name
            formData.append('file', selectedFile); // The actual file
            
            console.log("Uploading file:", {
                name: selectedFile.name,
                type: selectedFile.type,
                size: selectedFile.size
            });

            const uploadResponse = await Commons.UploadFile(
                API_HOST + "/files",
                formData,
                true
            );

            console.log("Upload response:", uploadResponse);

            if (!uploadResponse || !uploadResponse.id) {
                throw new Error("Upload response tidak valid");
            }

            if (!uploadResponse.filename_disk) {
                throw new Error("File tidak tersimpan di server");
            }

            // ✅ Step 2: Check if data_berkas with this type already exists
            console.log("Checking existing data_berkas...");
            
            const existingBerkas = await Commons.GetData(
                API_HOST + "/items/data_berkas",
                `filter[data_santri][_eq]=${idSantri}`,
                true
            );

            console.log("Existing data_berkas:", existingBerkas);

            let berkasId = null;
            let oldFileId = null;

            if (existingBerkas && existingBerkas.length > 0) {
                // ✅ Record exists - update it
                berkasId = existingBerkas[0].id;
                oldFileId = existingBerkas[0][typeFile]; // Save old file ID for deletion
                
                console.log("Updating existing data_berkas:", berkasId);

                const updatePayload = {
                    [typeFile]: uploadResponse.id, // Replace with new file ID
                };

                await Commons.UpdateData(
                    API_HOST + "/items/data_berkas/" + berkasId,
                    updatePayload,
                    true
                );

                console.log("data_berkas updated successfully");

            } else {
                // ✅ Record doesn't exist - create new
                console.log("Creating new data_berkas record");

                const createPayload = {
                    [typeFile]: uploadResponse.id,
                    data_santri: idSantri
                };

                const createResponse = await Commons.PostData(
                    API_HOST + "/items/data_berkas",
                    createPayload,
                    true
                );

                berkasId = createResponse.id;
                console.log("data_berkas created successfully:", berkasId);
            }

            // ✅ Step 3: Delete old file if exists (optional but recommended)
            if (oldFileId) {
                try {
                    console.log("Deleting old file:", oldFileId);
                    await Commons.DeleteData(
                        API_HOST + "/files/" + oldFileId,
                        true
                    );
                    console.log("Old file deleted successfully");
                } catch (deleteError) {
                    console.warn("Failed to delete old file:", deleteError);
                    // Don't throw error, continue anyway
                }
            }

            // Refresh parent component
            if (forceRefresh) {
                forceRefresh();
            }

            setNotifData({
                message: existingBerkas && existingBerkas.length > 0 
                    ? "Berhasil mengganti file" 
                    : "Berhasil upload file",
                status: "success"
            });

            // Reset form
            setSelectedFile(null);
            setTypeFile("");
            const fileInput = document.querySelector('input[type="file"]');
            if (fileInput) fileInput.value = null;

        } catch (error) {
            console.error("Upload error:", error);
            
            // Extract error message from Directus error format
            let errorMessage = "Gagal upload file";
            if (error.errors && Array.isArray(error.errors) && error.errors.length > 0) {
                errorMessage = error.errors.map(e => e.message).join(', ');
            } else if (error.message) {
                errorMessage = error.message;
            }
            
            setNotifData({
                message: errorMessage,
                status: "error"
            });
        } finally {
            setIsLoading(false);
            setIsShowNotif(true);
        }
    };

    return (
        <>
            <ShowNotif 
                isShow={isShowNotif} 
                actionClose={() => setIsShowNotif(false)} 
                data={notifData}
            />
            <Card>
                <CardHeader 
                    title="Upload Berkas/Bukti Pembayaran" 
                    sx={{ borderBottom: "1px solid #f4f4f4" }}
                />
                <CardContent>
                    <p>Upload berkas-berkas syarat pendaftaran melalui form berikut dengan ketentuan:</p>
                    <ul>
                        <li>Berkas dapat dibaca dengan jelas</li>
                        <li>Ukuran berkas dibawah 5MB</li>
                        <li>Berkas yang diupload harus menggunakan format JPG atau PNG</li>
                    </ul>
                    
                    <p><strong>Petunjuk Upload:</strong></p>
                    <ul>
                        <li>Harap upload berkas satu per satu</li>
                        <li>Pilih salah satu berkas yang akan diupload pada kolom Berkas</li>
                        <li>Pilih opsi Jenis Berkas</li>
                        <li>Tekan tombol Upload Sekarang</li>
                        <li>Ulangi langkah di atas untuk berkas yang lainnya</li>
                        <li><strong>Jika berkas sudah pernah diupload, file lama akan diganti dengan file baru</strong></li>
                    </ul>
                    
                    <hr />
                    
                    <Grid2 spacing={2} columns={24} container>
                        <Grid2 size={12}>
                            <FormLabel sx={{
                                color: "#000000",
                                fontWeight: "bold",
                                marginTop: "15px",
                                "::after": {
                                    content: '" *Wajib"',
                                    color: "red",
                                    fontWeight: "bold",
                                    fontStyle: "italic"
                                }
                            }}>
                                Jenis Berkas
                            </FormLabel>
                            <Select 
                                value={typeFile}
                                onChange={(e) => setTypeFile(e.target.value)}
                                name="jenis_berkas"
                                fullWidth
                                displayEmpty
                            >
                                <MenuItem value="">
                                    <em>Pilih Jenis Berkas</em>
                                </MenuItem>
                                {Object.entries(JENIS_BERKAS).map(([key, value]) => (
                                    <MenuItem key={key} value={key}>
                                        {value}
                                    </MenuItem>
                                ))}
                            </Select>
                        </Grid2>
                        
                        <Grid2 size={12}>
                            <FormLabel sx={{
                                color: "#000000",
                                fontWeight: "bold",
                                marginTop: "15px",
                                "::after": {
                                    content: '" *Wajib"',
                                    color: "red",
                                    fontWeight: "bold",
                                    fontStyle: "italic"
                                }
                            }}>
                                Berkas
                            </FormLabel>
                            <TextField
                                onChange={handleChange}
                                type="file"
                                fullWidth
                                inputProps={{
                                    accept: "image/jpeg,image/jpg,image/png"
                                }}
                                helperText={selectedFile ? `File terpilih: ${selectedFile.name}` : "Pilih file JPG atau PNG (max 5MB)"}
                            />
                        </Grid2>
                        
                        <Grid2 size={24}>
                            <LoadingButton
                                disabled={!typeFile || !selectedFile}
                                loading={isLoading}
                                loadingPosition="start"
                                sx={typeFile && selectedFile ? { backgroundColor: "#e96726", color: "white" } : {}}
                                startIcon={<CloudUpload />}
                                variant="contained"
                                fullWidth
                                onClick={UploadFile}
                            >
                                {isLoading ? "Processing..." : "Upload Sekarang"}
                            </LoadingButton>
                        </Grid2>
                    </Grid2>
                </CardContent>
            </Card>
        </>
    );
}

export default DetailUpload;